import { Component, Injectable, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IEUserAction, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { AppConfig } from '../../app.config';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { CosyHtmlElementGenerationService } from 'src/app/service/generator/generator-html/cosy-html-element-generation.service';
import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';


import {
  NgbCalendar,
  NgbDateAdapter,
  NgbDateStruct,
  NgbDateParserFormatter,
  NgbDate
} from '@ng-bootstrap/ng-bootstrap';

import BarcodeScanner from 'src/app/model/barcodeScanner';
import { element } from 'protractor';
import { LocaleTypes } from 'src/app/model/locale/locale-type';
import { DatePipe } from '@angular/common';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { InterfaceElementDataTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-datatype';
import cloneDeep from 'lodash-es/cloneDeep';

const scanner = BarcodeScanner();

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()

export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly de_DELIMITER = '.';
  readonly en_DELIMITER = '/';

  parse(value: string): NgbDateStruct {  
    let result: NgbDateStruct = null;
    if (value) {
      let date;

      if(value.hasOwnProperty('day')){
        result = {
          day: value['day'],
          month: value['month'],
          year: value['year']
        }
      }

      else if(value.hasOwnProperty('day') == null || value.indexOf(this.de_DELIMITER) >-1  ){
      
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeDE_CODE) date = value.split(this.de_DELIMITER);
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeEN_CODE) date = value.split(this.en_DELIMITER);
        result = {
          day: parseInt(date[0], 10),
          month: parseInt(date[1], 10),
          year: parseInt(date[2], 10)
        };
      }

      else if(value.hasOwnProperty('day') == null ||  value.indexOf(this.en_DELIMITER) >-1 ){
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeDE_CODE) date = value.split(this.de_DELIMITER);
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeEN_CODE) date = value.split(this.en_DELIMITER);
        result = {
          day: parseInt(date[1], 10),
          month: parseInt(date[0], 10),
          year: parseInt(date[2], 10)
        };
        CosyInputtextComponent.editedDateValue = result;
      }
    }
    return result;
  }

  format(date: NgbDateStruct): string {

    let result: string = null;
    let eng_result: string = null;

    if(date == null) {
      date = CosyInputtextComponent.editedDateValue;
    }
    if (date && CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeDE_CODE) {
      result = date.day.toString().length == 1 ? '0' + date.day + this.de_DELIMITER : date.day + this.de_DELIMITER;
      result += date.month.toString().length == 1 ? '0' + date.month + this.de_DELIMITER + date.year : date.month + this.de_DELIMITER + date.year;
    
      /*saving english format */
      eng_result = date.month.toString().length == 1 ? '0' + date.month + this.en_DELIMITER : date.month + this.en_DELIMITER;
      eng_result += date.day.toString().length == 1 ? '0' + date.day + this.en_DELIMITER + date.year : date.day + this.en_DELIMITER + date.year;
      CosyInputtextComponent.dateValue = eng_result;
      /*end*/
    }

    if (date && CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeEN_CODE) {
      result = date.month.toString().length == 1 ? '0' + date.month + this.en_DELIMITER : date.month + this.en_DELIMITER;
      result+= date.day.toString().length == 1 ? '0' + date.day + this.en_DELIMITER + date.year : date.day + this.en_DELIMITER + date.year;
    }
    
    return result;
  }

}



/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly de_DELIMITER = '.';
  readonly en_DELIMITER = '/';

  fromModel(value: string): NgbDateStruct {  
    
    let result: NgbDateStruct = null;
    if (value) {
      let date;

      if(value.hasOwnProperty('day')){
        result = {
          day: value['day'],
          month: value['month'],
          year: value['year']
        }
      }

      else if(value.hasOwnProperty('day') == null || value.indexOf(this.de_DELIMITER) >-1  ){
      
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeDE_CODE) date = value.split(this.de_DELIMITER);
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeEN_CODE) date = value.split(this.en_DELIMITER);
        result = {
          day: parseInt(date[0], 10),
          month: parseInt(date[1], 10),
          year: parseInt(date[2], 10)
        };
      }

      else if(value.hasOwnProperty('day') == null ||  value.indexOf(this.en_DELIMITER) >-1 ){
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeDE_CODE) date = value.split(this.de_DELIMITER);
        if(CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeEN_CODE) date = value.split(this.en_DELIMITER);
        result = {
          day: parseInt(date[1], 10),
          month: parseInt(date[0], 10),
          year: parseInt(date[2], 10)
        };
        CosyInputtextComponent.editedDateValue = result;
      }
    }
   
    return result;
  }

  toModel(date: NgbDateStruct): string {

    let result: string = null;
    let eng_result: string = null;

    if(date == null) {
      date = CosyInputtextComponent.editedDateValue;
    }
   
    if (date && CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeDE_CODE) {
      result = date.day.toString().length == 1 ? '0' + date.day + this.de_DELIMITER : date.day + this.de_DELIMITER;
      result += date.month.toString().length == 1 ? '0' + date.month + this.de_DELIMITER + date.year : date.month + this.de_DELIMITER + date.year;
    
      /*saving english format */
      eng_result = date.month.toString().length == 1 ? '0' + date.month + this.en_DELIMITER : date.month + this.en_DELIMITER;
      eng_result += date.day.toString().length == 1 ? '0' + date.day + this.en_DELIMITER + date.year : date.day + this.en_DELIMITER + date.year;
      CosyInputtextComponent.dateValue = eng_result;
      /*end*/
    }

    if (date && CosyCommunicationControllerService.currentLocale == LocaleTypes.LocaleTypeEN_CODE) {
      result = date.month.toString().length == 1 ? '0' + date.month + this.en_DELIMITER : date.month + this.en_DELIMITER;
      result+= date.day.toString().length == 1 ? '0' + date.day + this.en_DELIMITER + date.year : date.day + this.en_DELIMITER + date.year;
    }
    
    return result;
  }
}


@Component({
  selector: 'app-cosy-inputtext',
  templateUrl: './cosy-inputtext.component.html',
  styleUrls: ['./cosy-inputtext.component.css'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]

})
export class CosyInputtextComponent implements OnInit {
  @Input() ie: InterfaceElement;
  @Input() formgroup: FormGroup;
  @Input() label: boolean = false;
  private BackGroundInput: string = "form-control form-control-sm ";
  public ieValue : any ;
  public formClass : string = "";
  public isAPOS : boolean = false;
  public datePlaceHolder : string = "";
  public static dateValue : string ;
  public static editedDateValue: NgbDateStruct;
  
  afuConfig = {
    uploadAPI: {
      url: this.config.getConfig('apiURL') + 'dux/uploadFile',
    }
  };
 

  constructor(
    private config: AppConfig,
    private datePipe: DatePipe,
    private uxControllerService: UXControllerService,
    private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService, 
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private ngbCalendar: NgbCalendar, private dateAdapter: NgbDateAdapter<string>
  ) { 
    
  }

  ngOnInit() { 

    let ua: IEUserAction = new IEUserAction();
  
    if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE){
      this.datePlaceHolder = 'mm/dd/yyyy'; 
    }
    else if(this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE){
      this.datePlaceHolder = 'dd.mm.yyyy'; 
    }
    
    if (this.label!=null ){
        this.formClass = "mb-3 row";
    }
   
    if (this.ie.Attributes.OnChangeUAID == null) {
      ua = this.cosyHtmlElementGenerationService.generateInlineUAID(this.ie.TypeDID, null);
      this.ie.UserActions.push(ua);
      this.ie.Attributes.OnChangeUAID = ua.UserActionID;
    }

    let uaIndex = -1;
    uaIndex = this.ie.UserActions.map(function (e) {return e.UserActionID}).indexOf(this.ie.Attributes.OnChangeUAID)
    if(this.ie.UserActions.length > 0 &&  this.ie.UserActions[uaIndex].ActionProcessOnServer){
      this.isAPOS = true;
    }


    if (this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.Properties != null && this.ie.CustomizeOptions.Properties.Replace != null) {
      this.formgroup.controls[this.ie.InterfaceElementID].setValue(this.ie.Values[0].Value.replace(new RegExp(this.ie.CustomizeOptions.Properties.Replace, 'gi'),this.ie.CustomizeOptions.Properties.ReplaceWith));
    }

    if (this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.Properties != null && this.ie.CustomizeOptions.Properties.Replace != null) {
      this.formgroup.controls[this.ie.InterfaceElementID].setValue(this.ie.Values[0].Value.replace(new RegExp(this.ie.CustomizeOptions.Properties.Replace, 'gi'),this.ie.CustomizeOptions.Properties.ReplaceWith));
    }
    if (this.ie.Attributes.DisplayScopeDID != null && this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.DisplayScope != null) {
      let keys = Object.keys(this.ie.CustomizeOptions.DisplayScope);
      this.BackGroundInput += this.ie.CustomizeOptions.DisplayScope[keys.find(element => element == this.ie.Attributes.DisplayScopeDID)];
    }
    // initialize BarcodeScannner
    if (this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.DisplayType != null && this.ie.CustomizeOptions.DisplayType == 'barcode') {
      scanner.on(data => {
        let ieRef: InterfaceElement;
        let ieRefID: String = this.ie.CustomizeOptions.Properties.RefID;
        if (ieRefID != null) ieRef = this.getInterfaceElementByID(this.uxControllerService.ieEntity.InterfaceElements, ieRefID);
        if (ieRef.Values[0].Value == 'true') {
         this.fetchIEUserAction(this.ie.Attributes.OnChangeUAID, data, null, null, null, this.formgroup);
        }
      });
    }
    // initialize BarcodeScannner

    // handle if FormGroup is null
    if(this.formgroup == null){
      this.ieValue = '';
      if(this.ie.Values != null && this.ie.Values.length>0  ){
        this.ieValue = this.ie.Values[0].Value;
       
        if(this.ie.TypeDID == InterfaceElementTypes.InputDate || (this.ie.CustomizeOptions!= null && this.ie.CustomizeOptions.DisplayType == 'date')){
         
            let dateTimeStamp = this.ieValue;
            let date = new Date(dateTimeStamp);
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            let day = date.getDate();
          
            const dateIni = year +'-' +month+'-' +day;
            const iniYear =  Number(this.datePipe.transform(dateIni, 'yyyy'));
            const iniMonth =  Number(this.datePipe.transform(dateIni, 'MM'));
            const iniDay =  Number(this.datePipe.transform(dateIni, 'dd'));
            this.ieValue = {year: iniYear ,
              month: iniMonth ,
              day: iniDay}
        }
      }
    }
    // end
  }

  fetchIEUserAction(userActionID: string, value: any, attributeKey: string, additionalAttributes: any[], additionalInterfaceElements: InterfaceElement[], group: FormGroup) {
    
    if (userActionID != null) {  
      if(this.ie.CosyDataTypeID == InterfaceElementDataTypes.DateDT || (this.ie.CustomizeOptions!= null && this.ie.CustomizeOptions.DisplayType == 'date') ){
        if(CosyInputtextComponent.dateValue != null) value = CosyInputtextComponent.dateValue;
      }
      else {
        value = this.cosyHtmlElementGenerationService.sendValueOnLocale(value, this.ie);
      }
      this.uxControllerService.fetchIEUserAction(userActionID, this.ie, value, attributeKey, additionalAttributes, additionalInterfaceElements, group, null);
    }
  }

  setDocumentID(documentID: string, ie: InterfaceElement, group: FormGroup) {
    group.controls[ie.InterfaceElementID].setValue(documentID);
  }

  getInterfaceElement(ieList: InterfaceElement[], displayType: string): InterfaceElement {
    let ieIEReturn: InterfaceElement = null;
    ieList.forEach(ieIE => {
      let ieIEHelp: InterfaceElement = null;
      if (ieIEReturn == null && ieIE.CustomizeOptions != null && ieIE.CustomizeOptions.DisplayType == displayType) ieIEReturn = ieIE;
      if (ieIEReturn == null && ieIE.InterfaceElements != null) ieIEHelp = this.getInterfaceElement(ieIE.InterfaceElements, displayType);
      if (ieIEReturn == null && ieIEHelp != null) ieIEReturn = ieIEHelp;
    })
    return ieIEReturn;
  }

  getInterfaceElementByID(ieList: InterfaceElement[], refIE: String): InterfaceElement {
    let ieIEReturn: InterfaceElement = null;
    ieList.forEach(ieIE => {
      let ieIEHelp: InterfaceElement = null;
      if (ieIEReturn == null && ieIE.InterfaceElementID == refIE) ieIEReturn = ieIE;
      if (ieIEReturn == null && ieIE.InterfaceElements != null) ieIEHelp = this.getInterfaceElementByID(ieIE.InterfaceElements, refIE);
      if (ieIEReturn == null && ieIEHelp != null) ieIEReturn = ieIEHelp;
    })
    return ieIEReturn;
  }
}
